<template>
    <v-dialog
        v-if="show"
        v-model="show"
        persistent
        max-width="500px">
        <v-card
            height="460px">
            <div class="text-right pt-2 pr-2 close-text pointer" @click="closeModal()">X</div>
            <v-card-title class="content-center">
                <span class="headline">
                    {{ $vuetify.lang.t('$vuetify.importEmployeesFormModal.importEmployeeData') }}
                </span>
            </v-card-title>
            <v-card-text class="pb-0">
                <v-form>
                    <v-container>
                        <v-row>
                            <div class="result-box locale-font">
                                <v-container class="pb-0">
                                    <div class="result-title">
                                        <v-row>
                                            <v-col
                                                cols="9"
                                                class="result-label">
                                                {{ title }}
                                            </v-col>
                                            <v-col
                                                cols="3"
                                                class="result-value">
                                                {{ content.total }}
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div class="gray-line"></div>
                                    <div class="result-title">
                                        <v-row>
                                            <v-col
                                                cols="9"
                                                class="result-label">
                                                <span>
                                                    <img class="icon-status" :src="getIcon('success')"/>
                                                </span>
                                                {{ $vuetify.lang.t('$vuetify.importEmployeesFormModal.importEmployeeSuccess') }}
                                            </v-col>
                                            <v-col
                                                cols="3"
                                                class="result-value">
                                                {{ content.importEmployeeSuccess }}
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div class="result-title mb-2">
                                        <v-row>
                                            <v-col
                                                cols="9"
                                                class="result-label">
                                                <span>
                                                    <img class="icon-status" :src="getIcon('error')"/>
                                                </span>
                                                {{ $vuetify.lang.t('$vuetify.importEmployeesFormModal.imageUploadFailed') }}
                                            </v-col>
                                            <v-col
                                                cols="3"
                                                class="result-value">
                                                {{ content.imageUploadFailed }}
                                            </v-col>
                                        </v-row>
                                    </div>
                                    <div v-if="mode === 'image'">
                                        <div
                                            class="result-row"
                                            v-for="(description, key, index) in content"
                                            :key="index">
                                            <v-row
                                                v-if="handlerResultBox(key)">
                                                <v-col
                                                    cols="9"
                                                    class="result-label">
                                                    <span class="dot"></span>{{ getLabel(key) }}
                                                </v-col>
                                                <v-col
                                                    cols="3"
                                                    class="result-value">
                                                    {{ description }}
                                                </v-col>
                                            </v-row>
                                        </div>
                                    </div>
                                </v-container>
                                <div class="result-row">
                                    <v-col cols="12">
                                        <span style="color:#ff544a"> * </span>
                                        {{ $vuetify.lang.t('$vuetify.importEmployeesFormModal.pleaseReUploadTheFailed') }}
                                    </v-col>
                                </div>
                            </div>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions
                v-if="mode === 'image'"
                class="content-center">
                <v-btn
                    color="primary"
                    width="60%"
                    @click="goToDownload()">
                    <i class="mr-2 fal fa-download"></i>
                    {{ $vuetify.lang.t('$vuetify.importEmployeesFormModal.moreDetails') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import IconError from '@/assets/icon/icon-error.png'
import IconSuccess from '@/assets/icon/icon-success.png'
export default {
    name: 'ImportEmployeeResultModal',

    props: {
        mode: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        content: {
            type: Object,
            default: () => ({})
        },
        logData: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            show: false
        }
    },

    methods: {
        getLabel (key) {
            const textLabel = this.$vuetify.lang.t(`$vuetify.importEmployeesFormModal.${key}`)
            return ` ${textLabel}`
        },

        getIcon (key) {
            if (key === 'success') {
                return IconSuccess
            } else if (key === 'error') {
                return IconError
            }
        },

        handlerResultBox (key) {
            if (key !== 'total' && key !== 'importEmployeeSuccess' && key !== 'imageUploadFailed') {
                return true
            }
            return false
        },

        goToDownload () {
            const data = JSON.stringify(this.logData)
            const dateStr = this.$dateUtil.formatSerialDateTime(new Date())
            this.$utils.saveLocalFile(`${dateStr}_import_image.txt`, data)
            this.closeModal()
        },

        showModal () {
            this.show = true
        },

        closeModal () {
            this.show = false
        }
    }
}
</script>

<style lang="scss" scoped>
.content-center {
    display: flex;
    justify-content: center;
}

.close-text {
    color: #000;
    font-family: 'Prompt';
}

.gray-line {
    border-top: solid 1px #c7c7c7;
    margin-top: 15px;
    margin-bottom: 15px;
}

.result-box {
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    width: 100%;
    border-radius: 15px !important;
    padding: 15px;

    overflow-y: auto;
    &::-webkit-scrollbar {
        width: 8px;
        border-radius: 10px;
        background-color: #ffffff;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #555;
    }

    &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #ffffff;
    }

    .result-title {
        margin-top: 5px;
        line-height: 1.29;
        font-size: 16px;
        color: #131410;
        .result-label {
            padding: 6px 12px;
        }
        .result-value {
            padding: 6px 12px;
            text-align: right;
        }
    }

    .icon-status {
        width: 20px;
    }

    .result-row {
        font-size: 14px;
        color: #6c6c6c;
        .result-label {
            padding: 5px 12px 5px 40px;
        }
        .result-value {
            padding: 5px 12px 5px 40px;
            text-align: right;
        }
        .dot {
            margin: 2px;
            height: 5px;
            width: 5px;
            background-color: #6c6c6c;
            border-radius: 50%;
            display: inline-block;
        }
    }
}
</style>
